module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-standside.753f7686.svg";